import { createAction } from '@ngrx/store';

const subscribeToHeadquarterTopic = createAction('[Headquarter Effect] Subscribe to Headquarter Topic');

const unsubscribeToHeadquarterTopic = createAction('[Headquarter Effect] Unsubscribe to Headquarter Topic');

export const HqActions = {
  subscribeToHeadquarterTopic,
  unsubscribeToHeadquarterTopic,
};
